"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9961],{

/***/ 99821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
exports.IconRenderer = IconRenderer;
exports["default"] = IconRenderer; //# sourceMappingURL=IconRenderer.js.map


/***/ }),

/***/ 6076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgArrowLeft = function SvgArrowLeft(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 37 64"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M31.959 64L0 32 31.959 0l4.612 4.619L9.225 32l27.346 27.381L31.96 64z"
    }));
};
__webpack_unused_export__ = SvgArrowLeft;
exports.ZP = SvgArrowLeft; //# sourceMappingURL=ArrowLeft.js.map


/***/ }),

/***/ 16820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgArrowRight = function SvgArrowRight(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 37 64"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M4.613 64L0 59.381 27.346 32 0 4.619 4.613 0 36.57 32 4.613 64z"
    }));
};
__webpack_unused_export__ = SvgArrowRight;
exports.ZP = SvgArrowRight; //# sourceMappingURL=ArrowRight.js.map


/***/ }),

/***/ 97638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var Link = function Link(_a) {
    var href = _a.href, _b = _a.target, target = _b === void 0 ? "_self" : _b, _c = _a.underline, underline = _c === void 0 ? true : _c, _onClick = _a.onClick, _d = _a.className, className = _d === void 0 ? "" : _d;
    _a.iconColor;
    _a.rightSideIcon;
    var children = _a.children, rest = __rest(_a, [
        "href",
        "target",
        "underline",
        "onClick",
        "className",
        "iconColor",
        "rightSideIcon",
        "children"
    ]);
    return /*#__PURE__*/ React__default["default"].createElement("a", _extends({
        className: "".concat(!!className ? className : "", " ").concat(underline ? "underline" : "no-underline", " cursor-pointer hover:text-accent-2"),
        href: href,
        target: target,
        onClick: function onClick(e) {
            var _$_a, _b;
            _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
            if (target === "_blank") {
                // TODO: define a better way to avoid iframe target _blank restriction
                try {
                    if (window.self !== window.top) {
                        // Inside Iframe
                        (_$_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _$_a === void 0 ? void 0 : _$_a.call(e);
                        window.open(href);
                    }
                } catch (_c) {
                    //  Fail to access window may be due to frame constrains
                    try {
                        (_b = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _b === void 0 ? void 0 : _b.call(e);
                        window.open(href);
                    } catch (error) {
                        console.error("Failed to trigger iframe link target _blank\n".concat(error));
                    }
                }
            }
        }
    }, rest), children);
};
exports.rU = Link;
exports.ZP = Link; //# sourceMappingURL=Link.js.map


/***/ }),

/***/ 45468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var ThemeContext = /*#__PURE__*/ React.createContext({
    themeId: "",
    typographyComponents: {},
    brandVariables: {}
});
var useTheme = function useTheme() {
    return React.useContext(ThemeContext);
};
var TagRenderer = function TagRenderer(_a) {
    var children = _a.children, textTag = _a.textTag, rest = __rest(_a, [
        "children",
        "textTag"
    ]);
    if (typeof textTag === "string") {
        switch(textTag){
            case "h1":
                return /*#__PURE__*/ React__default["default"].createElement("h1", rest, children);
            case "h2":
                return /*#__PURE__*/ React__default["default"].createElement("h2", rest, children);
            case "h3":
                return /*#__PURE__*/ React__default["default"].createElement("h3", rest, children);
            case "h4":
                return /*#__PURE__*/ React__default["default"].createElement("h4", rest, children);
            case "h5":
                return /*#__PURE__*/ React__default["default"].createElement("h5", rest, children);
            case "h6":
                return /*#__PURE__*/ React__default["default"].createElement("h6", rest, children);
            case "span":
                return /*#__PURE__*/ React__default["default"].createElement("span", rest, children);
            case "p":
            default:
                return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
        }
    }
    return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
};
var LegacyText = function LegacyText(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.bold, bold = _d === void 0 ? false : _d, _e = _a.link, link = _e === void 0 ? false : _e;
    _a.id;
    var children = _a.children, _g = _a.textTag, textTag = _g === void 0 ? "p" : _g, rest = __rest(_a, [
        "className",
        "size",
        "bold",
        "link",
        "id",
        "children",
        "textTag"
    ]);
    var classes = "".concat(!!className ? className : "", " text-body-").concat(size, "-").concat(!!link ? "link" : !!bold ? "bold" : "normal");
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        className: classes,
        textTag: textTag
    }, rest), children);
};
var Text = function Text(_a) {
    var _b;
    var textId = _a.textId, className = _a.className, children = _a.children, _c = _a.textTag, textTag = _c === void 0 ? "p" : _c, rest = __rest(_a, [
        "textId",
        "className",
        "children",
        "textTag"
    ]);
    var typographyComponents = useTheme().typographyComponents;
    if (!textId || !typographyComponents) {
        return /*#__PURE__*/ React__default["default"].createElement(LegacyText, _extends({
            className: className,
            textTag: textTag
        }, rest), children);
    }
    var props = __assign({
        className: "".concat(className || "", " ").concat(textId)
    }, rest);
    var inputTag = textTag || ((_b = typographyComponents === null || typographyComponents === void 0 ? void 0 : typographyComponents[textId]) === null || _b === void 0 ? void 0 : _b.htmlComponent);
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        textTag: inputTag
    }, props), children);
};
__webpack_unused_export__ = LegacyText;
__webpack_unused_export__ = Text;
exports.ZP = Text; //# sourceMappingURL=Text.js.map


/***/ }),

/***/ 5300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var react = __webpack_require__(67294);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
var useIsVisible = function useIsVisible(previewElement) {
    var _a = __read(react.useState(false), 2), isVisible = _a[0], setIsVisible = _a[1];
    var isElementVisible = react.useCallback(function(_a) {
        var _b = _a.window, innerHeight = _b.innerHeight, innerWidth = _b.innerWidth, _c = _a.document.documentElement, clientHeight = _c.clientHeight, clientWidth = _c.clientWidth;
        if (!previewElement.current) {
            return false;
        }
        var _d = previewElement.current.getBoundingClientRect(), top = _d.top, left = _d.left, bottom = _d.bottom, right = _d.right;
        var height = innerHeight || clientHeight;
        var width = innerWidth || clientWidth;
        var verticallyInside = function verticallyInside(spot) {
            return spot >= 0 && spot <= height;
        };
        var horizontallyInside = function horizontallyInside(spot) {
            return spot >= 0 && spot <= width;
        };
        var topInside = verticallyInside(top);
        var bottomInside = verticallyInside(bottom);
        var leftInside = horizontallyInside(left);
        var rightInside = horizontallyInside(right);
        return topInside && leftInside || topInside && rightInside || bottomInside && leftInside || bottomInside && rightInside;
    }, [
        previewElement
    ]);
    var startLoadIfVisible = react.useCallback(function(_a) {
        var window1 = _a.window, document1 = _a.document;
        if (!isVisible && isElementVisible({
            window: window1,
            document: document1
        })) {
            setIsVisible(true);
        }
    }, [
        isElementVisible,
        isVisible
    ]);
    react.useEffect(function() {
        var loadBasedOnPosition = function loadBasedOnPosition() {
            return startLoadIfVisible({
                window: window,
                document: document
            });
        };
        loadBasedOnPosition();
        if (!isVisible) {
            window.addEventListener("scroll", loadBasedOnPosition);
        }
        return function() {
            return window.removeEventListener("scroll", loadBasedOnPosition);
        };
    }, [
        startLoadIfVisible,
        isVisible
    ]);
    return isVisible;
};
function useScrollWatcher(_a) {
    var _b = _a.id, id = _b === void 0 ? "" : _b;
    var _c = __read(react.useState(0), 2), scrollTop = _c[0], setScrollTop = _c[1];
    var _d = __read(react.useState(1), 2), verticalHeight = _d[0], setVerticalHeight = _d[1];
    var _e = __read(react.useState(false), 2), isScrollingUp = _e[0], setIsScrollingUp = _e[1];
    react.useEffect(function() {
        var onScroll = function onScroll(e) {
            if (typeof document !== "undefined" && "object" !== "undefined") {
                var currentScrollTop = window.scrollY;
                var currentVerticalHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                setScrollTop(currentScrollTop);
                setVerticalHeight(currentVerticalHeight);
                if (currentVerticalHeight === verticalHeight) {
                    var currentIsScrollingUp = currentScrollTop <= 0 || currentScrollTop < scrollTop;
                    setIsScrollingUp(currentIsScrollingUp);
                }
            }
        };
        if (typeof document !== "undefined" && "object" !== "undefined") {
            window.addEventListener("scroll", onScroll);
            return function() {
                return window.removeEventListener("scroll", onScroll);
            };
        }
    }, [
        id,
        scrollTop,
        verticalHeight
    ]);
    var isAtTheTop = react.useMemo(function() {
        if (false) {}
        var scrollPercent = scrollTop / verticalHeight * 100;
        return scrollPercent <= 0;
    }, [
        scrollTop,
        verticalHeight
    ]);
    return {
        isAtTheTop: isAtTheTop,
        isScrollingUp: isScrollingUp
    };
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var browsersNamePattern = /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i;
var getBrowserNameAndVersion = function getBrowserNameAndVersion() {
    try {
        if ( true && _typeof(window.navigator) === "object") {
            var browserMatches = window.navigator.userAgent.match(browsersNamePattern) || [];
            if (/trident/i.test(browserMatches[1])) {
                var tem = /\brv[ :]+(\d+)/g.exec(window.navigator.userAgent) || [];
                return {
                    name: "IE",
                    version: tem[1] || 0
                };
            }
            if (browserMatches[1] === "Chrome") {
                var operaVersionMatch = window.navigator.userAgent.match(/\bOPR|Edge\/(\d+)/);
                if (operaVersionMatch !== null) {
                    return {
                        name: "Opera",
                        version: operaVersionMatch[1]
                    };
                }
            }
            var nameAndVersionMatch = browserMatches[2] ? [
                browserMatches[1],
                browserMatches[2]
            ] : [
                navigator.appName,
                navigator.appVersion,
                "-?"
            ];
            var versionRegexMatch = window.navigator.userAgent.match(/version\/(\d+)/i);
            if (versionRegexMatch !== null) {
                nameAndVersionMatch.splice(1, 1, versionRegexMatch[1]);
            }
            var browsername = nameAndVersionMatch[0];
            var version = parseFloat(nameAndVersionMatch[1]);
            if (!Number.isNaN(version)) {
                return {
                    name: browsername,
                    version: version
                };
            }
        }
    } catch (error) {}
    return null;
};
var shouldRender = function shouldRender() {
    var browser = getBrowserNameAndVersion();
    var shouldSendTrue = !browser || /safari/ig.test(browser.name) && typeof browser.version === "number" && browser.version < 12;
    if (typeof IntersectionObserver === "undefined") {
        return true;
    }
    return shouldSendTrue;
};
function useOnScreen(ref) {
    var _a = __read(react.useState(shouldRender()), 2), isIntersecting = _a[0], setIntersecting = _a[1];
    react.useEffect(function() {
        if (!isIntersecting && ref.current) {
            try {
                var observer_1 = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        return setIntersecting(function(visible) {
                            return visible || entry.isIntersecting;
                        });
                    });
                });
                observer_1.observe(ref.current); // Remove the observer as soon as the component is unmounted
                return function() {
                    observer_1.disconnect();
                };
            } catch (err) {
                console.log("useOnScreen failed: ".concat(err));
                setIntersecting(true);
            }
        }
    }, [
        ref,
        isIntersecting
    ]);
    return isIntersecting;
}
function useIsAtTheTop(_a) {
    var _b = _a.id, id = _b === void 0 ? "" : _b;
    var _c = __read(react.useState(0), 2), scrollTop = _c[0], setScrollTop = _c[1];
    var _d = __read(react.useState(1), 2), verticalHeight = _d[0], setVerticalHeight = _d[1];
    react.useEffect(function() {
        var onScroll = function onScroll(e) {
            if (typeof document !== "undefined" && "object" !== "undefined") {
                var currentScrollTop = window.scrollY;
                var currentVerticalHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                setScrollTop(currentScrollTop);
                setVerticalHeight(currentVerticalHeight);
            }
        };
        if (typeof document !== "undefined" && "object" !== "undefined") {
            window.addEventListener("scroll", onScroll);
            return function() {
                return window.removeEventListener("scroll", onScroll);
            };
        }
    }, [
        id,
        scrollTop,
        verticalHeight
    ]);
    var isAtTheTop = react.useMemo(function() {
        var scrollPercent = scrollTop / verticalHeight * 100;
        return scrollPercent <= 0;
    }, [
        scrollTop,
        verticalHeight
    ]);
    return isAtTheTop || "object" === "undefined";
}
__webpack_unused_export__ = useIsAtTheTop;
__webpack_unused_export__ = useIsVisible;
exports.RO = useOnScreen;
exports.d8 = useScrollWatcher; //# sourceMappingURL=hooks.js.map


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);